import devHelper from '../../util/devHelper'
import dbHelper from '../../util/db'
import functions from '../../functions'
import msgbus from '../../msgBus'
import i18n from '../../lang/index'


var g_fileWholeName = '' // 当前第三方发起浏览文件的路径+文件名
const g_edsAPPFileDir = 'edsFiles' // edsAPP存放文件的目录名:APP目录/files/edsFiles/ + msgbus.vm.getAccountID()

// 异步检查存储权限
function asyncCheckStoragePermission() {
  return new Promise((resolve, reject) => {
    if (msgbus.vm.getPlatform() == 'Android') {
      window.cordova.plugins.gsfileview.CallFunction(
        false,
        'CheckPermission',
        function (hasPermission) {
          if (!hasPermission) {
            msgbus.vm.setRequestStorage({
              value: {
                visible: true,
                callback: function (grant) {
                  if (grant) {
                    window.cordova.plugins.gsfileview.CallFunction(
                      grant,
                      'CheckPermission',
                      function (granted) {
                        resolve(granted)
                      },
                      function (error) {
                        reject(error)
                      }
                    )
                  } else {
                    resolve(false)
                  }
                }
              }
            })
          } else {
            resolve(true)
          }
        },
        function (error) {
          if (((typeof error === 'object' && error.message) || error) === 'cordova组件接口中没有定义指定的action操作。') { // 兼容1.0.17.44等旧壳
            resolve(true)
          } else {
            reject(error)
          }
        }
      )
    } else {
      resolve(true)
    }
  })
}

var edsfileview = {

  // 处理意图（android系统）
  funcHandleIntent(Intent) {
    if (Intent.action == 'android.intent.action.VIEW') {
      g_fileWholeName = Intent.data
    }
  },

  // 打开文件
  funcEdsFileOpen() {
    if (g_fileWholeName != '') {
      // alert('funcEdsFileOpen:' + g_fileWholeName)
      var fileWholeName = g_fileWholeName
      // 置全局为空
      g_fileWholeName = ''

      if (msgbus.vm.getPlatform() === 'Android') {
        asyncCheckStoragePermission().then(hasPermission => {
          if (hasPermission) {
            // 打开文件
            edsfileview.edsFileOpen(fileWholeName)
          }
        }).catch(error => {
          const message = (typeof error === 'object' && error.message) || error
          msgbus.vm.setSnackBar({
            value: {
              color: 'error',
              text: message,
              visible: true
            }
          })
        })
      } else {
        // 打开文件
        edsfileview.edsFileOpen(fileWholeName)
      }
    }
  },

  // 打开文件
  edsFileOpen(fileWholeName) {
    if (msgbus.vm.getPlatform() === 'Android') {
      asyncCheckStoragePermission().then(hasPermission => {
        if (hasPermission) {
          window.cordova.plugins.gsfileview.CallFunction(
            fileWholeName,
            'TransRealPath',
            function (successFileName) { // 对文件名进行处理,成功时
              // 对文件名进行处理,成功时：回调拷贝文件g_fileW到EDS-APP指定目录，并打开文件
              fileWholeName = 'file://' + successFileName
              functions.edsfileview.funcCopyFile(fileWholeName)
            },
            function (errorMsg) {
              alert('转换文件名错误:' + fileWholeName)
            })
        }
      }).catch(error => {
        const message = (typeof error === 'object' && error.message) || error
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: message,
            visible: true
          }
        })
      })
    } else {
      functions.edsfileview.funcCopyFile(fileWholeName)
    }
  },
  // 拷贝文件到APP指定目录（例：QQ目录到EDSAPP目录）
  funcCopyFile(filePath) {
    // alert('funcCopyFile:' + filePath)
    // alert('funcCopyFile:' + window.cordova.file.externalDataDirectory + g_edsAPPFileDir + '/' + msgbus.vm.getAccountID())
    if (msgbus.vm.getPlatform() === 'Android') {
      window.resolveLocalFileSystemURL(
        filePath, // 需要拷贝的文件路径+名称
        function (fileEntry) { // 回调
          window.resolveLocalFileSystemURL(
            window.cordova.file.externalDataDirectory,
            function (dirEntry) { // 读取目录： files
              dirEntry.getDirectory( // 读取目录：files/edsFiles 如果目录不存在，则创建edsFiles命名的子目录
                g_edsAPPFileDir,
                { create: true },
                function (subDirEntry) {  // 回调
                  subDirEntry.getDirectory( // 读取目录：files/edsFiles/账号ID 如果目录不存在，则创建以“账号ID”命名的子目录
                    msgbus.vm.getAccountID(),
                    { create: true },
                    function (subAccountDirEntry) {
                      // 回调
                      fileEntry.copyTo( // 拷贝文件
                        subAccountDirEntry,
                        fileEntry.name,
                        function (success) { // 拷贝文件成功后回调
                          functions.edsfileview.successCallback_copyFile(fileEntry, subAccountDirEntry) //
                        },
                        function (error) {
                        })
                    },
                    function (error) {
                    })
                },
                function (error) {
                })
            },
            function (error) {
            })
        },
        function (error) {
        })
    } else {
      window.resolveLocalFileSystemURL(
        'file://' + filePath, // 需要拷贝的文件路径+名称
        function (fileEntry) { // 回调
          window.resolveLocalFileSystemURL(
            window.cordova.file.documentsDirectory,
            function (dirEntry) { // 读取目录： files
              dirEntry.getDirectory( // 读取目录：files/edsFiles 如果目录不存在，则创建edsFiles命名的子目录
                g_edsAPPFileDir,
                { create: true },
                function (subDirEntry) {  // 回调
                  subDirEntry.getDirectory( // 读取目录：files/edsFiles/账号ID 如果目录不存在，则创建以“账号ID”命名的子目录
                    msgbus.vm.getAccountID(),
                    { create: true },
                    function (subAccountDirEntry) {
                      // 回调
                      fileEntry.copyTo( // 拷贝文件
                        subAccountDirEntry,
                        fileEntry.name,
                        function (success) { // 拷贝文件成功后回调
                          functions.edsfileview.successCallback_copyFile(fileEntry, subAccountDirEntry) //
                        },
                        function (error) {
                          if (error.code == 12) {
                            functions.edsfileview.successCallback_copyFile(fileEntry, subAccountDirEntry)
                          }
                        })
                    },
                    function (error) { })
                },
                function (error) { })
            },
            function (error) { })
        },
        function (error) { })
    }
  },
  // 拷贝文件成功后回调的具体文件处理逻辑
  successCallback_copyFile(fileEntry, dirEntry) {
    // alert('successCallback_copyFile_fileEntry:' + JSON.stringify(fileEntry))
    // alert('successCallback_copyFile_dirEntry:' + JSON.stringify(dirEntry))
    var finalPath = dirEntry.nativeURL + fileEntry.name
    var fileWholeName = finalPath.substring(7)  // 转换gsfileview要求的文件格式，即去除file://
    // 读取文件信息并写Sqlite数据库打开文件信息
    let fileInfo = {
      isFlowFile: 0, // 0 标识非流程文件
      fileWholeName: fileWholeName, // 路径+文件名
      fileName: fileEntry.name, // 文件名（物理文件名）
      flowID: '', // 流程ID
      flowName: '', // 流程名称
      flowFileURL: '', // 流程文件下载URL
      flowFileName: '', // 流程文件名
      tid: '',
      tname: '',
      fileID: ''
    }
    this.funcGetFileInfo(fileInfo, 1)
  },
  //------------------------------------------------------------------------------------------------

  // 删除文件
  funcDeleteFile(fileWholeName) {
    if (msgbus.vm.getPlatform() == 'Android') {
      asyncCheckStoragePermission().then(hasPermission => {
        if (hasPermission) {
          // alert('fileWholeName' + fileWholeName)
          var finalPath = 'file://' + fileWholeName
          window.resolveLocalFileSystemURL(finalPath, function (fs) {
            fs.remove()
          })
        }
      }).catch(error => {
        const message = (typeof error === 'object' && error.message) || error
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: message,
            visible: true
          }
        })
      })
    } else {
      // alert('fileWholeName' + fileWholeName)
      var finalPath = 'file://' + fileWholeName
      window.resolveLocalFileSystemURL(finalPath, function (fs) {
        fs.remove()
      })
    }
  },

  /*
   读取文件信息
   fileInfo{
    isFlowFile：标识是否是流程文件，1 是；0 否
    fileWholeName： 符合gsfileview结构的文件路径+文件名，即去除file://
    flowFileName: 若流程文件，则传流程中显示的文件名，例：测试.dox,否则传空,

   }
   isOpenFile: 读完信息后，是否打开文件
   读取结果：
   {"encrypted":true,"key":"1384337904","userOID":10679,"orgID":10671,"clID":6,"fileID":0}
  */
  funcGetFileInfo(fileInfo, isOpenFile) {
    // alert('读取文件信息:' + fileWholeName)
    var datalist = {
      fileName: fileInfo.fileWholeName,
      //     keys: ['1384337904'],
      keys: msgbus.vm.getAccountTenantKeys() //[B2gKA89qKfT0C3MhPxpGvTSkEAQYlUndP3u/hiFiQ+uLaw,B2gKA89qKfT0C3MhPxpGvTSkEAQYlUndP3u/hiFiQ+uLaw==]
    }
    // 判断是否开启了测试模式，若是，执行测试代码
    if (devHelper.isDevMode()) {
      alert('GetFileInfo:' + JSON.stringify(datalist))
    }

    if (msgbus.vm.getPlatform() == 'Android') {
      asyncCheckStoragePermission().then(hasPermission => {
        if (hasPermission) {
          // alert('GetFileInfo:' + JSON.stringify(datalist))
          window.cordova.plugins.gsfileview.CallFunction(
            datalist,
            'GetFileInfo',
            function (successMsg) { // 拷贝文件成功后回调
              functions.edsfileview.successCallback_GetFileInfo(successMsg, fileInfo, isOpenFile)
            },
            function (errorMsg) {
              if (devHelper.isDevMode()) {
                alert('FileBrowsing errorMsg' + errorMsg)
              }
              let fileName = fileInfo.isFlowFile ? fileInfo.flowFileName : functions.edsfileview.getFileName(fileInfo.fileWholeName)
              msgbus.vm.setSnackBar({
                value: {
                  color: 'error',
                  text: i18n.t('文件[{name}] 打开失败，可能该加密文件不属于当前企业', { name: fileName }),
                  visible: true
                }
              })
            })
        }
      }).catch(error => {
        const message = (typeof error === 'object' && error.message) || error
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: message,
            visible: true
          }
        })
      })
    } else {
      // alert('GetFileInfo:' + JSON.stringify(datalist))
      window.cordova.plugins.gsfileview.CallFunction(
        datalist,
        'GetFileInfo',
        function (successMsg) { // 拷贝文件成功后回调
          functions.edsfileview.successCallback_GetFileInfo(successMsg, fileInfo, isOpenFile)
        },
        function (errorMsg) {
          if (devHelper.isDevMode()) {
            alert('FileBrowsing errorMsg' + errorMsg)
          }
          let fileName = fileInfo.isFlowFile ? fileInfo.flowFileName : functions.edsfileview.getFileName(fileInfo.fileWholeName)
          msgbus.vm.setSnackBar({
            value: {
              color: 'error',
              text: i18n.t('文件[{name}] 打开失败，可能该加密文件不属于当前企业', { name: fileName }),
              visible: true
            }
          })
        })
    }
  },
  successCallback_GetFileInfo(successMsg, fileInfo, isOpenFile) {
    if (devHelper.isDevMode()) {
      alert('successCallback_GetFileInfo: ' + JSON.stringify(successMsg))
    }

    // 若文件是加密文件，且有key返回，则根据key读取租户信息，否则根据fileInfo中读取
    if (fileInfo.tid == '' && successMsg.encrypted.toString() == 'true') {
      // 根据key，读取tid,tname
      let tid = functions.login.funcGetTidBaseKey(successMsg.key)
      if (!tid) {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: i18n.t('没有权限预览，因为无租户信息'),
            visible: true
          }
        })
        return
      }
      // 根据tid，读取tname
      let tname = functions.login.funcGetTnameBaseTid(tid)

      // 更新fileInfo信息
      fileInfo.tid = tid
      fileInfo.tname = tname
    }


    if (devHelper.isDevMode()) {
      alert('fileInfo: ' + JSON.stringify(fileInfo))
    }
    var writeFileInfo = {
      isFlowFile: fileInfo.isFlowFile, // 是否流程文件
      fileWholeName: fileInfo.fileWholeName, // 路径+文件名
      fileName: fileInfo.fileName, // 文件名(物理文件存放文件名，若是流程文件则是：tid +fid + flowFileName)
      flowID: fileInfo.flowID, // 流程ID
      flowName: fileInfo.flowName, // 流程名称
      flowFileURL: fileInfo.flowFileURL, // 流程文件下载URL
      flowFileName: fileInfo.flowFileName, // 流程文件名
      encrypted: successMsg.encrypted, // 文件是否加密
      key: '', // 密钥不记入本地数据库
      userOID: successMsg.userOID, // 用户OID
      orgID: successMsg.orgID, // 组织OID
      clID: successMsg.clID, // 文件密级
      fileID: fileInfo.fileID, // 文件ID,
      tid: fileInfo.tid,
      tname: fileInfo.tname,
      downloadPer: 100
    }
    if (devHelper.isDevMode()) {
      alert('writeFileInfo: ' + JSON.stringify(writeFileInfo))
    }
    // 写Sqlite本地数据库打开文件信息
    this.funcWriteSqlite(writeFileInfo)


    // 如有有预览标识，则下载完成执行本地预览
    if (isOpenFile == 1) {
      // 解密并打开文件
      if (msgbus.vm.getPlatform() === 'Android') {
        functions.edsfileview.funcFileBrowsing(fileInfo)
      } else {
        this.fileBrowseIOS(fileInfo)
      }

    }
  },
  fileBrowseIOS(fileInfo) {
    setTimeout(function () { // 解决在ios版本中查看文件后会卡死的问题，也就是通过异步调用解决
      functions.edsfileview.funcFileBrowsing(fileInfo)
    }, 100)
  },
  //------------------------------------------------------------------------------------------------

  // 写Sqlite本地数据库打开文件信息
  funcWriteSqlite(fileInfo) {
    // alert('funcWriteSqlite')
    // 写记录到数据库：先判断记录是否存在，若存在，则修改，否则新建
    functions.sqliteHelper.recordItemToRecent_file(fileInfo).then(() => {
      // 查询最近下载的文档总数(目的界面刷新)
      msgbus.vm.fetchRecentFilesTotalCount().then(() => {
        // 查询最近下载文档(目的界面刷新)
        var data = {
          skip: 0,
          limit: 10
        }
        msgbus.vm.fetchRecentFiles({ data: data }).then(() => {
        })
        msgbus.vm.fetchDownloadFiles({ data: data }).then(() => {
        })
      })
    })
  },
  //------------------------------------------------------------------------------------------------

  // 解密文件并预览
  funcFileBrowsing(fileInfo) {
    // 判断是否开启了测试模式，若是，执行测试代码
    if (devHelper.isDevMode()) {
      alert('解密文件并预览:' + fileInfo.fileWholeName)
    }

    // 转换中间四位为***
    let mobileNo = msgbus.vm.getAccountInfo().mobileNo
    mobileNo = mobileNo.substring(0, 3) + '****' + mobileNo.substring(7)
    // alert('mobileNo:' + mobileNo)

    const email = msgbus.vm.getAccountInfo().email

    // 根据tid，读取key
    let tentanKey = functions.login.funcGetKeyBaseTid(fileInfo.tid)


    if (tentanKey.length < 1) {
      tentanKey = '0'
    }

    var datalist = {
      fileName: fileInfo.fileWholeName,
      // key: '1384337904',
      key: tentanKey,//'B2gKA89qKfT0C3MhPxpGvTSkEAQYlUndP3u/hiFiQ+uLaw=='
      watermark: fileInfo.tname + ' ' + (mobileNo !== '****' ? mobileNo : email)
    }
    if (devHelper.isDevMode()) {
      alert('FileBrowsing:' + JSON.stringify(datalist))
    }
    if (msgbus.vm.getPlatform() == 'Android') {
      asyncCheckStoragePermission().then(hasPermission => {
        if (hasPermission) {
          window.cordova.plugins.gsfileview.CallFunction(
            datalist,
            'FileBrowsing',
            this.successCallback,
            function (errorMsg) {
              if (devHelper.isDevMode()) {
                alert('FileBrowsing errorMsg' + errorMsg)
              }
              let fileName = fileInfo.isFlowFile ? fileInfo.flowFileName : fileInfo.fileName
              msgbus.vm.setSnackBar({
                value: {
                  color: 'error',
                  text: i18n.t('文件[{name}] 打开失败，可能该加密文件不属于当前企业', { name: fileName }),
                  visible: true
                }
              })
            })
        }
      }).catch(error => {
        const message = (typeof error === 'object' && error.message) || error
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: message,
            visible: true
          }
        })
      })
    } else {
      window.cordova.plugins.gsfileview.CallFunction(
        datalist,
        'FileBrowsing',
        this.successCallback,
        function (errorMsg) {
          if (devHelper.isDevMode()) {
            alert('FileBrowsing errorMsg' + errorMsg)
          }
          let fileName = fileInfo.isFlowFile ? fileInfo.flowFileName : fileInfo.fileName
          msgbus.vm.setSnackBar({
            value: {
              color: 'error',
              text: i18n.t('文件[{name}] 打开失败，可能该加密文件不属于当前企业', { name: fileName }),
              visible: true
            }
          })
        })
    }
  },
  //------------------------------------------------------------------------------------------------

  successCallback(msg) {
    // alert('调用成功: ' + msg)
  },
  errorCallback(msg) {
    alert('调用失败: ' + msg)
  },
  //------------------------------------------------------------------------------------------------

  getFileName(path) {
    var pos1 = path.lastIndexOf('/')
    var pos2 = path.lastIndexOf('\\')
    var pos = Math.max(pos1, pos2)
    if (pos < 0) {
      return path
    } else {
      return path.substring(pos + 1)
    }
  },
  GetOpenAsFileName() {
    var that = this
    var data = ''
    window.cordova.plugins.gsfileview.CallFunction(data, 'GetOpenAsFileName', function (res) {


      if (res.length > 0) {
        window.cordova.plugins.gsfileview.CallFunction('', 'SetOpenAsFileName', null, null)
        let fileName = res.substring(res.lastIndexOf('/') + 1, res.length)
        let fileInfo = {
          isFlowFile: 0, // 0 标识非流程文件
          fileWholeName: res, // 路径+文件名
          fileName: fileName, // 文件名（物理文件名）
          flowID: '', // 流程ID
          flowName: '', // 流程名称
          flowFileURL: '', // 流程文件下载URL
          flowFileName: '', // 流程文件名
          tid: '',
          tname: '',
          fileID: ''
        }
        that.funcGetFileInfo(fileInfo, 1)
      }


    }, null)
  },
  //------------------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------
  //---------------------以下为测试接口，现不用，暂保留------------------------------------------------
  //------------------------------------------------------------------------------------------------


  // CallGetFileInfo(fileName) {
  //   var that = this
  //   var data = fileName
  //   var key = ['1', '2', '1384337904']
  //   var datalist = { 'fileName': data, 'keys': key }
  //   cordova.plugins.gsfileview.CallFunction(datalist, 'GetFileInfo', function(res) {
  //     that.CallFileBrowsing(res.key, fileName)
  //
  //   }, function(err) {
  //     alert(err)
  //   })
  //
  // },
  // CallFileBrowsing(key, fileName) {
  //   var data = fileName
  //   var that = this
  //
  //
  //   var datalist = { 'fileName': data, 'key': '1384337904', 'watermark': '12345' }
  //   cordova.plugins.gsfileview.CallFunction(datalist, 'FileBrowsing', null, null)
  //
  // },
  // 解密文件并预览（测试接口，现不用，暂保留）
  funcDecodeFileAndShow(fileName) {
    // 判断是否开启了测试模式，若是，执行测试代码
    if (devHelper.isDevMode()) {
      alert('解密文件并预览:' + fileName)
    }
    window.cordova.plugins.gsfileview.CallFunction(fileName, 'DecodeFileAndShow', this.successCallback, this.errorCallback)
  },

  // 写localstorage本地数据库打开文件信息（测试时接口，现不用，暂保留）
  funcWriteLocalStorage(isFlowFile, fileWholeName, fileName) {
    // alert('funcWriteLocalStorage')
    // 读取本地数据库文件信息
    var recentFilesTemp = dbHelper.get('recentFiles')
    var recentFileList = recentFilesTemp ? JSON.parse(recentFilesTemp) : []

    var fileInfo = {
      isFlowFile: isFlowFile, // 是否流程文件
      fileWholeName: fileWholeName, // 路径+文件名
      fileName: fileName, // 文件名
      encrypted: true, // 文件是否加密
      key: '', // 打开加密文件所用的密钥
      userOID: '', // 用户OID
      orgID: '', // 组织OID
      clID: '', // 文件密级
      fileID: '', // 文件ID,
      tid: '5e7978dd25085a621cdb57d3',
      tname: '杭州数络信息技术有限公司'
    }

    var fileFileTemp = recentFileList.filter(file => file.fileName.toLowerCase() == fileInfo.fileName.toLowerCase())
    if (fileFileTemp.length == 0) {
      // 追加文件信息到列表首地址
      recentFileList.unshift(fileInfo)
    } else {
      // 最新打开的文件移动到列表首地址
      for (var i = 0; i < recentFileList.length; i++) {
        if (recentFileList[i].fileName.toLowerCase() === fileInfo.fileName.toLowerCase()) {
          recentFileList.splice(i, 1)
          break
        }
      }
      recentFileList.unshift(fileInfo)
    }

    // 写本地数据库文件信息
    dbHelper.set('recentFiles', JSON.stringify(recentFileList))
  }
  //------------------------------------------------------------------------
  //---------------------以上为测试接口，现不用，暂保留------------------------
  //------------------------------------------------------------------------
}
export default edsfileview

